import { render } from "./TemplateFrameDetails.vue?vue&type=template&id=4f42d61d"
import script from "./TemplateFrameDetails.vue?vue&type=script&lang=js"
export * from "./TemplateFrameDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__